import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import dataTableData from "./data/dataTableData";
import { useEffect, useState } from "react";
import { RequestService } from "services/RequestService";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router-dom";
import MDAvatar from "components/MDAvatar";
import { imageUrl } from "services/RequestService";
import { Button, TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import Grid from "@mui/material/Grid";
import FormField from "components/Form/FormField";
import Icon from "@mui/material/Icon";
import CustomNavbar from "components/CustomNavbar";
function ProjectManagersDataTables() {
  const navigate = useNavigate();

  const [dataTableData2, setDataTableData] = useState(dataTableData);
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [projectIdToDelete, setProjectIdToDelete] = useState(null);
  const [pms, setPms] = useState([]);
  const [ProjectManagerIds, setProjectManagerIds] = useState([]);
  const [CurrentProjectManagerId, setCurrentProjectManagerId] = useState(null);
  const [ProjectId, setProjectId] = useState(null);
  const [ProjectManagerToDelete, setProjectManagerToDelete] = useState(null);
  const [projectName, setProjectName] = useState(null);
  // const [ProjectManagerId, setProjectManagerId] = useState(0);
 // read project id from url
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  const toggleSnackbar = () => setShow(!show);
  const toggleSnackbar2 = () => setError(!error);

  const handleOpenDialog = (id) => {
    setProjectManagerToDelete(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setProjectManagerToDelete(null);
  };

  const handleConfirmDelete = async () => {
    if (ProjectManagerToDelete) {
      ProjectManagerIds.pop(CurrentProjectManagerId);
      let js = { id: ProjectId, projectManagerIds: ProjectManagerIds };
      RequestService.put("Project/ProjectManager", js)
        .then((response) => {
          if (response.status === 200) {
            toggleSnackbar();
            fetchProjects(ProjectId); // Refresh data after successful deletion
          } else {
            toggleSnackbar2();
          }
        })
        .catch((error) => {
          console.error("Error deleting project:", error);
          toggleSnackbar2();
        });
      handleCloseDialog();
    }
  };

  const fetchProjects = async (id) => {
    //
    try {
      const response = await RequestService.get(`Project/ProjectManagers/${id}`);
      if (response.data.error === false) {
        var PmIds = [];
        const projectData = response.data.data.map((r, index) => {
          // Convert project managers array to string
          // r.projectManager = r.projectManager.map((pm) => pm.displayName).join(", ");
          PmIds.push(r.id);
          r.actions = (
            <MDBox display="flex">
              {/* <MDButton
                href={`/projects/project/edit?id=${r.id}`}
                sx={{ marginRight: 2 }}
                color="info"
                variant="outlined"
              >
                تعديل
              </MDButton> */}
              <MDButton 
                variant="outlined"
                color="error"
                size="small"
                onClick={() => handleOpenDialog(r.id)}
                startIcon={<Icon>delete</Icon>}
              >
                حذف
              </MDButton>
            </MDBox>
          );
          r["#"] = index + 1;
          let imagepath = imageUrl + r.imageUrl;
          r["imageUrl"] = (
            <Button
              onClick={() => {
                // Open image in new tab
                window.open(imagepath);
              }}
            >
              <MDAvatar src={imagepath} size="lg" />;
            </Button>
          );
          return r;
        });
        // let js = { id: id, ProjectManagerIds: PmIds };
        setProjectManagerIds(PmIds);
        setDataTableData((prevState) => ({
          ...prevState,
          rows: projectData,
        }));
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  const getAllPm = async () => {
    let options = [];
    await RequestService.get("/Project/ProjectManagers").then((response) => {
      if (response.status === 200 && response.data.data !== null) {
        let js = response.data.data;
        js.map((value, key) => {
          options.push({
            value: value.id,
            label: value.userName,
          });
        });
      }
    });
    setPms(options);
  };
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id");
    setProjectId(id);
    fetchProjects(id);
    getAllPm();
    RequestService.get(`Project/GetProjectById/${id}`)
      .then((response) => {
        if (response.status === 200) {
          setProjectName(response.data.data.name);
        }
      })
      .catch((error) => {
        console.error("Error fetching project name:", error);
      });
  }, []);
  const isOptionEqualToValue = (option, value) => option.id === value.id;

  return (
    <DashboardLayout>
      <CustomNavbar
        title={"Project Managers"}
        route={[
          { path: "pages/projects/viewprojects", display: "المشاريع" },
          { path: `projectinfo?id=${id}`, display: "المشروع" },
          { path: "pages/projects/projectManagers", display: "مدراء المشروع" }
        ]}
      />
      <MDSnackbar
        color="success"
        icon="notifications"
        title="تم اتمام العملية"
        content="تم اتمام العملية بنجاح"
        dateTime="منذ 0 ثانية"
        open={show}
        close={toggleSnackbar}
      />

      <MDSnackbar
        color="error"
        icon="notifications"
        title="اضافة مدير المشروع"
        content="حدث خطأ ما"
        dateTime="منذ 0 ثانية"
        open={error}
        close={toggleSnackbar2}
      />
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox p={3} lineHeight={1}>
            <MDTypography variant="h5" fontWeight="medium">
              مدراء المشاريع
            </MDTypography>
          </MDBox>
          <MDBox p={1} style={{ display: "flex", justifyContent: "center" }}>
            <Grid container spacing={3}>
              <Grid item xs={3} sm={4}></Grid>
              <Grid item xs={5} sm={4}>
                <MDButton
                  onClick={() => {
                    // navigate("/pages/projects/project/add");

                    // alert(JSON.stringify(ProjectManagerIds));
                    if (!CurrentProjectManagerId) return;
                    
                    ProjectManagerIds.push(CurrentProjectManagerId);
                    let js = { id: ProjectId, projectManagerIds: ProjectManagerIds };
                    RequestService.put("Project/ProjectManager", js)
                      .then((response) => {
                        if (response.status === 200) {
                          toggleSnackbar();
                          fetchProjects(ProjectId); // Refresh data after successful deletion
                        } else {
                          toggleSnackbar2();
                        }
                      })
                      .catch((error) => {
                        console.error("Error deleting project:", error);
                        toggleSnackbar2();
                      });
                  }}
                  style={{ width: "100%" }}
                  color="info"
                  disabled={!CurrentProjectManagerId}
                >
                  إضافة
                </MDButton>
              </Grid>
              <Grid item xs={12} sm={12}></Grid>
              <Grid item xs={3} sm={4}></Grid>

              <Grid item xs={5} sm={4}>
                <Autocomplete
                  variant="outlined"
                  options={pms}
                  style={{ width: "100%", height: "100%" }}
                  isOptionEqualToValue={isOptionEqualToValue}
                  renderInput={(params) => (
                    <TextField {...params} label="مدير المشروع" variant="outlined" />
                  )}
                  onChange={(e, v) => {
                    setCurrentProjectManagerId(v.value);
                  }}
                />
              </Grid>
            </Grid>
          </MDBox>
          <DataTable table={dataTableData2} canSearch />
        </Card>
      </MDBox>
      <Footer />

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="confirm-delete-dialog-title"
      >
        <DialogTitle id="confirm-delete-dialog-title">تأكيد الحذف</DialogTitle>
        <DialogContent>
          <DialogContentText>سيتم حذف بيانات هذا الحقل بشكل نهائي. هل أنت متأكد؟</DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleConfirmDelete} color="error">
            نعم
          </MDButton>
          <MDButton onClick={handleCloseDialog} color="secondary">
            لا
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default ProjectManagersDataTables;
